import { useEffect } from "react";
import "./App.css";
import { Toaster } from "@/components/ui/sonner";
import { initLenis } from "@/lib/lenis";
import { LandingPage } from "@/pages/LandingPage";

function App() {
  useEffect(() => {
    initLenis();
  }, []);

  return (
    <div className="App">
      <LandingPage />
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
